import * as Papa from "papaparse";
import { saveAs } from "file-saver";
export default class Utils {
  constructor() {}

  static convertBase64ToFile(base64String, fileName) {
    let arr = base64String.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let uint8Array = new Uint8Array(n);
    while (n--) {
      uint8Array[n] = bstr.charCodeAt(n);
    }
    let file = new File([uint8Array], fileName, { type: mime });
    return file;
  }

  static load(url) {
    return fetch(url)
      .then((data) => data.json())
      .then((json) => json);
  }

  static loadImage(url) {
    return fetch(url)
      .then((data) => data.blob())
      .then((blob) => {
        console.log(blob.type);
        if (blob.type == "application/json") {
          return { message: "no image" };
        } else {
          return URL.createObjectURL(blob);
        }
      });
  }

  static dist(a, b, c, d) {
    return Math.sqrt(Math.pow(c - a, 2) + Math.pow(d - b, 2));
  }

  static lerp(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
  }

  static save(content, fileName, contentType = "image/png") {
    // var a = document.createElement("a");
    // // let file = new Blob([content], { type: contentType });

    // a.href = content; //URL.createObjectURL(file);
    // a.download = fileName;
    // // a.target = "_blank";
    // // a.click();
    // // document.body.removeChild(a);

    // a.style.display = "none";
    // document.body.appendChild(a);
    // a.click(); //Downloaded file
    // document.body.removeChild(a);

    let file = Utils.convertBase64ToFile(content, fileName);
    saveAs(file, fileName);
  }

  static map(x, inMin, inMax, outMin, outMax) {
    return ((x - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }

  static postImage(b64, url, worker) {
    const param = {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        image: b64,
      }),
    };
    worker.postMessage({
      url: url,
      param: param,
    });
  }

  static postData(imageURL, imagePARAM) {
    return fetch(imageURL, imagePARAM).then((data) => data.json());
  }

  // https://stackoverflow.com/questions/20958078/resize-a-base-64-image-in-javascript-without-using-canvas
  // Resize a base64 image with an offsreen canvas
  static imageToDataUri(img, width, height) {
    // create an off-screen canvas
    var canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");

    // set its dimension to target size
    canvas.width = width;
    canvas.height = height;

    // draw source image into the off-screen canvas:
    ctx.drawImage(img, 0, 0, width, height);

    // encode image to data-uri with base64 version of compressed image
    return canvas.toDataURL();
  }

  static isMobileLayout() {
    // Tachyons breakpoints used for the css
    // @media screen and (min-width: 30em)
    const notSmallRule = "(min-width: 30em)";
    const isMobile = !window.matchMedia(notSmallRule).matches;
    return isMobile;
  }

  static isMediumLayout() {
    const mediumRule = "(min-width: 30em) and (max-width: 40em)";
    const isMedium = window.matchMedia(mediumRule).matches;
    return isMedium;
  }

  static isSmallOrMediumLayout() {
    // tachyon rule for large
    // screen and (min-width: 40em)
    const largeRule = "(min-width: 40em)";
    const isSmallOrMedium = !window.matchMedia(largeRule).matches;
    return isSmallOrMedium;
  }

  static isLandscapeMobile() {
    // screen and (max-width: 960px) and (max-height: 600px) and (orientation: landscape)
    const rule =
      "(max-width: 960px) and (max-height: 500px) and (orientation: landscape)";
    const isLandscape = window.matchMedia(rule).matches;
    return isLandscape;
  }

  static loadMultipleCSV(CSVList) {
    const combinedData = [];
    return Promise.all(
      [...CSVList].map(
        (file) =>
          new Promise((resolve, reject) =>
            Papa.parse(file, {
              download: true,
              complete: resolve,
              error: reject,
            })
          )
      )
    ).then((results) => {
      results.forEach((result, index) => {
        combinedData.push(...result.data);
      });
      const c = combinedData.filter((item) => item[0] != "");
      return c;
    });
  }

  static async fetchAssetInfo(id) {
    const testUrl = `${GLOBAL_PATH}og/${id}`;
    const response = await fetch(testUrl);
    const data = await response.json();
    const title = data.title || "";
    let author = "";
    if (data.creators) author = data.creators[0].title || "";
    const partner = data.partner || "";
    const src = data.image.url + "=w500";
    // replace http by https if needed
    const secureSrc = src.replace("http://", "https://");
    const fetchedItem = {
      title: title,
      author: author,
      partner: partner,
      assetid: id,
      src: secureSrc,
    };
    return fetchedItem;
  }

  static sendToBucket(url, b64Image) {
    return fetch(url, {
      method: "POST",
      body: JSON.stringify({
        image: b64Image,
      }),
      cache: "no-cache",
      headers: new Headers({
        "content-type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {});
  }

  static addWaterMark(watermark, b64Image, width, height) {
    return new Promise((resolve, reject) => {
      let canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      let logo = new Image();
      logo.onload = () => {
        let image = new Image();
        image.onload = function () {
          ctx.drawImage(image, 0, 0);
          ctx.drawImage(logo, 0, image.height - logo.height);
          resolve(canvas.toDataURL());
        };
        image.src = b64Image;
      };
      logo.src = watermark;
    });
  }
}
